import type { ReactNode } from 'react'
import { I } from './Icons'

/** The mark at the top of every done screen. `ok` (the black circle, the tick draws on, one ring), `warn` (orange "!"),
 *  `cancelled` (grey "×"), and `paid`: the Starchive star turns in with a quarter turn and one ring. The star is the
 *  Paid mark for every payment method; the tick means done everywhere else. Under Reduce Motion every variant stands still. */
export type DoneKind = 'ok' | 'warn' | 'cancelled' | 'paid'
export function DoneMark({ kind = 'ok', className = '' }: { kind?: DoneKind; className?: string }) {
  if (kind === 'paid') {
    return <div className={'done__tick done__tick--paid ' + className} aria-hidden="true"><span className="done__ring" /><span className="done__star" /></div>
  }
  const bg = kind === 'warn' ? '#ff9500' : kind === 'cancelled' ? '#8e8e93' : undefined
  return (
    <div className={'done__tick done__tick--' + kind + ' ' + className} style={bg ? { background: bg } : undefined} aria-hidden="true">
      {kind === 'ok' && <span className="done__ring" />}
      {kind === 'ok' ? <span className="done__draw">{I.tick()}</span> : <span style={{ color: '#fff', fontSize: 34, fontWeight: 700 }}>{kind === 'warn' ? '!' : '×'}</span>}
    </div>
  )
}

/** The result lines under the mark come in one after another: wrap each in this with its index. */
export function DoneLine({ i, children }: { i: number; children: ReactNode }) {
  return <div className="done__item done__item--in" style={{ ['--i' as string]: i }}>{children}</div>
}

/** A result line that is still waiting on a job: the star tick, then its tick when the job lands. */
export function DoneDot({ state }: { state: 'wait' | 'ok' | 'warn' }) {
  if (state === 'wait') return <span className="startick startick--dot" aria-hidden="true" />
  return <span className={'dot ' + state + ' dot--in'}>{state === 'ok' ? I.tick(12) : <span style={{ color: '#fff', fontSize: 12, fontWeight: 700 }}>!</span>}</span>
}
